import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getCustomerDisplayName(customer: { 
  name: string; 
  company?: string | null; 
  isPrivatePerson?: boolean | null;
}): string {
  if (customer.isPrivatePerson) {
    return customer.name;
  }
  return customer.company || customer.name;
}
